import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext({});

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    ga4_id: "",
    social_linkedin: "",
    social_facebook: "",
    social_instagram: "",
    social_youtube: "",
    social_twitter: "",
  });

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  // Inject GA4 script when ga4_id present (admin can set later)
  useEffect(() => {
    const id = settings.ga4_id;
    if (!id || document.getElementById("ga4-script")) return;
    const s1 = document.createElement("script");
    s1.async = true;
    s1.id = "ga4-script";
    s1.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(s1);
    const s2 = document.createElement("script");
    s2.id = "ga4-init";
    s2.text = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${id}');`;
    document.head.appendChild(s2);
  }, [settings.ga4_id]);

  return (
    <SettingsContext.Provider value={settings}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
